module.exports = __webpack_public_path__ + "src/assets/games/28/15.jpg";